import { environment } from '@environments/environment';
import { AppInsightsService } from './insights.service';
import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class ApplicationInsightsErrorHandler extends ErrorHandler {
  constructor(private appInsightsService: AppInsightsService) {
    super();
  }

  handleError(error: Error) {
    if (!environment.production) {
      // eslint-disable-next-line no-console
      console.log(error);
    }
    if (environment.appInsights.logErrors) {
      this.appInsightsService.logException(error); // Manually log exception
    }
  }
}
